import {copyTextToClipboard, extractFields, formatNumber, formSetErrors, setErrors} from "./functions";

$(document).on('submit', 'form.js-web-form', function (e) {
    e.preventDefault();

    let fields = extractFields(this),
        data = {fields};

    const $form = $(this);
    const formType = $form.data('type');
    const $submit = $form.find('.submit');

    // if (this.enctype === 'multipart/form-data') {
        data = new FormData(this);
    // }

    $submit.attr('disabled', true);

    BX.ajax.runAction(`palladiumlab:http.WebFormController.${formType}`, {data})
        .then(function (response) {
            emitter.emit(`web-form-${formType}-send-success`, {
                response,
                form: $form,
            });
            $submit.removeAttr('disabled');
            window.location.href = '/spasibo';
        })
        .catch(function (response) {
            setErrors($('.modal-sent-error .modal-desc'), response.errors || []);
            emitter.emit(`web-form-${formType}-send-error`, {
                response,
                form: $form,
            });
            Modal.openModal('modal-sent-error');
            $submit.removeAttr('disabled');
        });
});

$(document).on('click', '.modal-close-btn', function () {
    $(this).closest('.modal').removeClass('active')
});

$(function () {
    function calculatePrice(priceParams, itemNode) {
        priceParams['USE_LOCK'] = false;
        priceParams['USE_MOUNTING'] = false;
        priceParams['USE_DELIVERY'] = false;

        priceParams['ITEM_NODE'] = itemNode;

        emitter.emit('calculate-product-price', priceParams);
    }

    emitter.on('calculate-product-price-result', function (result) {
        if (result.itemNode) {
            let $priceBlock = $(result.itemNode).find('.products-item-prices');
            let formattedPrice = result.formattedPrice;
            let priceParams = $(result.itemNode).data('price-params-item');
            let price = result.price;
            let oldPrice = result.price;
            let oldPriceFormatted = result.formattedPrice;
            let basePrice = result.priceData.basePrice;

            if (priceParams['PRICE_DISCOUNT_PERCENT'] > 0 && priceParams['PRICE_DISCOUNT_PERCENT'] < 100){
                price = Math.round(basePrice * ((100 - priceParams['PRICE_DISCOUNT_PERCENT']) / 100));
                price+= result.priceData.deliveryPrice + result.priceData.lockPrice + result.priceData.mountingPrice;
                formattedPrice = String(new Intl.NumberFormat('ru-RU').format(price));
            }

            if (priceParams['USE_PER_METER'] && priceParams['SIZES'][0] > 0 && priceParams['SIZES'][1] > 0){
                //steklyannye-peregorodki
                let pricePerMeter = Math.round(price / (priceParams['SIZES'][0] * priceParams['SIZES'][1]));
                formattedPrice = String(new Intl.NumberFormat('ru-RU').format(pricePerMeter));
                let oldPricePerMeter = Math.round(oldPrice / (priceParams['SIZES'][0] * priceParams['SIZES'][1]));
                oldPriceFormatted = String(new Intl.NumberFormat('ru-RU').format(oldPricePerMeter));
            }
            $priceBlock.find('.products-item-price-current span').text(formattedPrice);
            $priceBlock.find('.products-item-price-old ').html(`<span>${oldPriceFormatted}</span> &nbsp;₽`);
        }
    });

    $.each($('[data-price-params-item]'), function (index, node) {
        if ($(node).data('use-calculator')) {
            calculatePrice($(node).data('price-params-item'), node);
        }
    });
});

window.extractFields = extractFields;
window.formatNumber = formatNumber;
window.formSetErrors = formSetErrors;
window.setErrors = setErrors;
window.copyTextToClipboard = copyTextToClipboard;
